<template>
  <div class="default-bg">
    <top-navigation class="mb-5">
      <div slot="middle">
        <h1>FACT CARDS</h1>
        <h3>WHY NOT TEST YOUR MATES?</h3>
      </div>
      <template slot="right">
      </template>
    </top-navigation>
    <div class="pl-5 pr-5 fact-cards-wrapper">
      <div class="fact-cards">
        <div class="fact-card" :key="index" v-for="(factCard, index) in factCardsList">
          <router-link v-if="factCards.includes(factCard.ID)" :to="{ name: 'FactCard', params: { id: factCard.ID.toString()} }">
            <img :src="factCard.meta.image_1">
          </router-link>
          <div v-else class="empty">
            <div><img class="lock" src="../../assets/img/locked.png" /></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-4 middle">
          <h1><span class="white">{{ factCards.length }}</span> / {{ factCardsList.length }}</h1>
        </div>
        <div class="col-4 middle loading-text-wrapper credits">
          Red Kangaroo: © Jurgen And Christine Sohns / FLPA / Minden Pictures. Zebra: © Getty Images. Grizzly Bear: © Andy Rouse / Nature Picture Library. Sugar glider:  © Nature Picture Library. Highland cow: © Getty Images. Pygmy goat: © Getty Images. Ribbon Seal: © FLPA. Picasso Bug: © Getty Images. Matschie's tree kangaroo: © Kevin Schafer / Getty Images.  Gouldian Finch: © Getty Images. Pink Fairy Armadillo: © Science Photo Library. Yellow Boxfish: © Getty Images.
        </div>
        <div class="col-4 logo">
          <img src="../../assets/img/logo.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation'
import { mapGetters } from 'vuex'

export default {
  name: 'FactCards',
  components: {
    TopNavigation
  },
  computed: {
    ...mapGetters(['factCards', 'factCardsList'])
  }
}
</script>

<style scoped>
  h1 {
    font-size: 4vw;
    margin-top: 1vh;
    font-family: "Geograph-Bold";
    color: #ffbf00;
  }

  h3 {
    font-size: 1.5vw;
    color: #fff;
    font-family: "Geograph-Black";
  }

  .fact-cards img {
    width: 100%;
  }

  .empty {
    width: 100%;
    height: 100%;
    border: 10px solid #feca2f;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 5vh;
  }

  .fact-cards-wrapper {
    display: flex;
    justify-content: center;
  }

  .fact-cards {
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(4, 22vh);
    grid-template-rows: repeat(3, calc(22vh * 0.7));
    grid-column-gap: 1vw;
    grid-row-gap: 1vw;
    grid-auto-rows: minmax(10vh, auto);
    grid-auto-columns: minmax(10vh, auto);
    float: left;
  }

  .fact-card {
    grid-auto-rows: 1fr;
  }

  .credits {
    color: #ffffff;
    text-align: center;
    font-size: 1.1vh;
  }
</style>
